// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"060e140c","405":"1aa3e013","481":"5386130f","650":"5386130f","660":"c0ed4e78"}[chunkId] + ".chunk.css";
};